import React, { useState, useEffect } from "react"
import Loader from "../../Loader/loader.js"
import { Row, Col } from "reactstrap"
import axios from "axios"
import { getCurrentUser, getPermission } from "../../../helpers/Utils.js"
import Paginations from "../../Pagination/index.jsx"
import GroupList from "./grouplist.js"
import GroupModal from "./groupmodal.js"
import AssignUsersModal from "./assignusersmodal.js"
import InputFilter from "../../Filter/SearchFilter/index.jsx"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const TableGroups = props => {
  const [modal_standard, setmodal_standard] = useState(false)
  const [assignUsersModal, setAssignUsersModal] = useState(false)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [allGroups, setAllGroups] = useState([])
  const [error, setError] = useState("")
  const [loader, setLoader] = useState(<Loader />)
  const [allPages, setAllPages] = useState([])
  const [counter, setCounter] = useState("")
  const [name_filter, setname_filter] = useState(false)
  const [searchedCount, setSearchedCount] = useState("")

  const getAllGroups = () => {
    setLoader(<Loader />)
    setAllGroups([])
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/groups?per_page=${
          localStorage.getItem("PerPage") !== null
            ? localStorage.getItem("PerPage")
            : ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.success) {
          setLoader("")
          setError("")
          setCounter(1)
          setAllGroups(res.data.data)
          setAllPages({
            data: res.data.data,
            per_page: 10,
            total: res.data.data.length,
          })
        } else {
          setLoader("")
          setError(res.data.message)
        }
      })
      .catch(err => {
        setLoader("")
        setError("Failed to fetch groups")
      })
  }

  const getSearchedGroups = (e, type) => {
    setError("")
    if (type == "name") {
      localStorage.setItem("groupName", e)
    }

    setSearchedCount("")
    setAllGroups([])
    setLoader(<Loader />)

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/groups?search=${
          localStorage.getItem("groupName") !== null
            ? localStorage.getItem("groupName")
            : ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.success) {
          setLoader("")
          setCounter(1)
          setAllGroups(res.data.data)
          setAllPages({
            data: res.data.data,
            per_page: 10,
            total: res.data.data.length,
          })
          setSearchedCount(res.data.data.length)
          setname_filter(false)
        } else {
          setLoader("")
          setError(res.data.message)
        }
      })
      .catch(err => {
        setLoader("")
        setError("Failed to search groups")
      })
  }

  const openAssignUsersModal = group => {
    setSelectedGroup(group)
    setAssignUsersModal(true)
  }

  useEffect(() => {
    getAllGroups()
  }, [])

  return (
    <>
      {modal_standard ? (
        <GroupModal
          modal_standard={modal_standard}
          setmodal_standard={setmodal_standard}
          getAllGroups={getAllGroups}
          selectedGroup={selectedGroup}
          setSelectedGroup={setSelectedGroup}
          openAssignUsersModal={openAssignUsersModal}
        />
      ) : (
        ""
      )}

      {assignUsersModal ? (
        <AssignUsersModal
          modal_standard={assignUsersModal}
          setmodal_standard={setAssignUsersModal}
          selectedGroup={selectedGroup}
          getAllGroups={getAllGroups}
        />
      ) : (
        ""
      )}

      <div className="page-title-box">
        <Row className="align-items-center">
          <Col md={6}>
            <h6 className="page-title">Groups Management</h6>
          </Col>
          <Col md={6}>
            <h6 className="page-title float-end">
              <button
                className="btn btn-success"
                onClick={() => {
                  setSelectedGroup(null)
                  setmodal_standard(true)
                }}
              >
                Add New Group
              </button>
            </h6>
          </Col>
        </Row>
        <Row>
          <Col>
            {searchedCount !== "" ? (
              <h6 className="">
                Searched Results
                <span> ({searchedCount})</span>
              </h6>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </div>

      <div className="lead_table table table-sm table-bordered table-responsive">
        <table style={{ width: "100%", background: "#fff" }}>
          <tbody>
            <tr className="static-header">
              <th>#</th>
              <th>
                <div
                  className="position-relative"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Group Name
                  {name_filter ? (
                    <>
                      <span
                        style={{ cursor: "pointer", color: "orange" }}
                        onClick={() => setname_filter(false)}
                      >
                        <i className="fa fa-times fa-lg ms-2"></i>
                      </span>
                    </>
                  ) : (
                    <>
                      {localStorage.getItem("groupName") == "" ? (
                        <span
                          className=""
                          style={{ cursor: "pointer" }}
                          onClick={() => setname_filter(true)}
                        >
                          <i className="fa fa-filter ms-2"></i>
                        </span>
                      ) : (
                        <span
                          className=""
                          style={{ cursor: "pointer", color: "orange" }}
                          onClick={() => setname_filter(true)}
                        >
                          <i className="fa fa-filter ms-2"></i>
                        </span>
                      )}
                    </>
                  )}
                  <InputFilter
                    name_filter={name_filter}
                    setname_filter={setname_filter}
                    getSearchedLeads={getSearchedGroups}
                  />
                </div>
              </th>
              <th>Description</th>
              <th>Users Count</th>
              <th>Created Date</th>
              <th>Actions</th>
            </tr>
            {allGroups &&
              allGroups.map((item, obj) => (
                <GroupList
                  key={obj}
                  data={item}
                  i={obj}
                  counter={counter}
                  getAllGroups={getAllGroups}
                  setSelectedGroup={setSelectedGroup}
                  setmodal_standard={setmodal_standard}
                  openAssignUsersModal={openAssignUsersModal}
                />
              ))}
          </tbody>
        </table>
        {error ? (
          <span className="text-danger mt-3 d-table m-auto" role="alert">
            {error}
          </span>
        ) : (
          ""
        )}
      </div>

      {loader}

      {allPages && allPages.data && allPages.data.length > 0 ? (
        <Paginations
          data={allPages}
          paginate={() => {}} // Simple pagination for now
          perPage={getAllGroups}
        />
      ) : (
        ""
      )}
    </>
  )
}

export default TableGroups
